<script setup lang="ts">
import { useAccordionSlot } from "./useAccordionItem";
useAccordionSlot("header");
</script>

<template>
  <slot />
</template>

<style>
:host {
  display: contents;
}
</style>
